export const CardPointeRpaWorkflowLoadingOutcome = {
    LOADED: 'loaded',
    MISSING_PACKAGE: 'missing_package',
    MALFORMED_WORKFLOWS: 'malformed_workflows',
} as const;

export type CardPointeRpaWorkflowLoadingOutcome =
    (typeof CardPointeRpaWorkflowLoadingOutcome)[keyof typeof CardPointeRpaWorkflowLoadingOutcome];

export const CardPointeRpaCapabilityStatus = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    UNSUPPORTED: 'unsupported',
} as const;

export type CardPointeRpaCapabilityStatus =
    (typeof CardPointeRpaCapabilityStatus)[keyof typeof CardPointeRpaCapabilityStatus];

export const CardPointeRpaCapabilityName = {
    CARD_PRESENT_TERMINAL_SALE: 'card_present_terminal_sale',
    CARD_NOT_PRESENT_TOKEN_SALE: 'card_not_present_token_sale',
    STORED_CARD_PAYMENT: 'stored_card_payment',
    TRANSACTION_STATUS_LOOKUP: 'transaction_status_lookup',
    TERMINAL_ABORT: 'terminal_abort',
    TERMINAL_TOKENIZATION: 'terminal_tokenization',
    ACH_PAYMENT: 'ach_payment',
} as const;

export type CardPointeRpaCapabilityName =
    (typeof CardPointeRpaCapabilityName)[keyof typeof CardPointeRpaCapabilityName];

export const CardPointeRpaWorkflowId = {
    TERMINAL_SALE: 'cardpointe_terminal_sale',
    TERMINAL_ABORT: 'cardpointe_terminal_abort',
    RECORD_CARD_TOKEN: 'cardpointe_record_card_token',
    CNP_TOKEN_SALE: 'cardpointe_cnp_token_sale',
    STORED_CARD_PAYMENT: 'cardpointe_stored_card_payment',
    TRANSACTION_STATUS: 'cardpointe_transaction_status',
    ACH_PAYMENT: 'cardpointe_ach_payment',
} as const;

export type CardPointeRpaWorkflowId =
    (typeof CardPointeRpaWorkflowId)[keyof typeof CardPointeRpaWorkflowId];

export interface CardPointeEnabledRpaCapability {
    readonly status: typeof CardPointeRpaCapabilityStatus.ENABLED;
}

export interface CardPointeDisabledRpaCapability {
    readonly status: typeof CardPointeRpaCapabilityStatus.DISABLED;
    readonly disabledReason: string;
}

export interface CardPointeUnsupportedRpaCapability {
    readonly status: typeof CardPointeRpaCapabilityStatus.UNSUPPORTED;
    readonly unsupportedReason: string;
}

export type CardPointeRpaCapability =
    | CardPointeDisabledRpaCapability
    | CardPointeEnabledRpaCapability
    | CardPointeUnsupportedRpaCapability;

export type CardPointeRpaCapabilityMetadata = {
    readonly [CapabilityName in CardPointeRpaCapabilityName]: CardPointeRpaCapability;
};

export interface CardPointeRpaWorkflowLoadingRequestDetails {
    readonly packageName: 'cardpointe-ipg';
    readonly requestedWorkflowIds: readonly CardPointeRpaWorkflowId[];
}

export interface CardPointeRpaWorkflowDescriptor {
    readonly id: CardPointeRpaWorkflowId;
    readonly capabilityName: CardPointeRpaCapabilityName;
    readonly enabled: boolean;
    readonly showInMenu: boolean;
}

export interface CardPointeRpaWorkflowLoadingNormalizedResult {
    readonly packageName: 'cardpointe-ipg';
    readonly workflowIds: readonly CardPointeRpaWorkflowId[];
    readonly loadedWorkflowCount: number;
    readonly enabledWorkflowCount: number;
    readonly capabilities: CardPointeRpaCapabilityMetadata;
}

export type CardPointeRpaWorkflowLoadingResponseDetails =
    | {
          readonly outcome: typeof CardPointeRpaWorkflowLoadingOutcome.LOADED;
          readonly workflows: readonly CardPointeRpaWorkflowDescriptor[];
          readonly normalizedResult: CardPointeRpaWorkflowLoadingNormalizedResult;
      }
    | {
          readonly outcome: typeof CardPointeRpaWorkflowLoadingOutcome.MISSING_PACKAGE;
          readonly packageName: 'cardpointe-ipg';
          readonly message: string;
      }
    | {
          readonly outcome: typeof CardPointeRpaWorkflowLoadingOutcome.MALFORMED_WORKFLOWS;
          readonly packageName: 'cardpointe-ipg';
          readonly message: string;
          readonly workflowIds?: readonly string[];
      };
